import { DateString, nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { EntityStatus } from './entity-status.type';

const RequestForQuotationSupplierLookup = t.type(
  {
    id: t.string,
    number: nullable(t.string),
    scope: nullable(t.string),
    status: nullable(EntityStatus),
    dueDate: DateString,
    finalDestinationCountry: nullable(t.string),
    projectSCM: nullable(t.string),
    canView: t.boolean,
  },
  'RequestForQuotationSupplierLookup',
);

type RequestForQuotationSupplierLookup = t.TypeOf<
  typeof RequestForQuotationSupplierLookup
>;
export { RequestForQuotationSupplierLookup };
